import React, { Suspense, useContext } from 'react';

// Context:
import { MobileContext } from '../../domain/context/MobileContext';

import type { PropsFromRedux } from '.';

const YMaps = React.lazy(
  () => import(/* webpackChunkName: "Map" */ './YandexMapsExplore'),
);

interface IMapWrapper extends PropsFromRedux {
  marginTop?: string;
}

export const MapWrapper = (props: IMapWrapper) => {
  const { browser, isOpen, marginTop } = props;

  const isMobile = useContext(MobileContext);

  const showOnMobile = isMobile && isOpen;
  const showOnDesktop = !isMobile && browser.greaterThan.large;

  return (
    <Suspense fallback={<div />}>
      {showOnMobile && <YMaps isOpen={isOpen} />}
      {showOnDesktop && <YMaps marginTop={marginTop} />}
    </Suspense>
  );
};
